import { render, staticRenderFns } from "./DepositForm.vue?vue&type=template&id=5bebe092&scoped=true"
import script from "./DepositForm.vue?vue&type=script&lang=js"
export * from "./DepositForm.vue?vue&type=script&lang=js"
import style0 from "./DepositForm.vue?vue&type=style&index=0&id=5bebe092&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bebe092",
  null
  
)

export default component.exports